export const settings = {
      title: 'Settings',
      subtitle: 'General system parameters',
      security: 'Security and access',
      securityDescription:
        'Manage users, access levels, and operational control.',
      manageUsers: 'Manage users',
      financialSettings: 'Financial settings',
      financialSettingsDescription:
        'Manage the operational exchange rate used between Mexican pesos and U.S. dollars.',
      basicCatalogs: 'Basic catalogs',
      basicCatalogsDescription:
        'Manage warehouses, categories, units, packaging types, and movement types.',
      commercialCatalogs: 'Commercial catalogs',
      commercialCatalogsDescription:
        'Centralize base information for customer types, suppliers, and customers.',
      customerTypesTitle: 'Customer types',
      customerTypesDescription: 'Classify customers by commercial profile and business relationship.',
      previewLabel: 'Action',
      back: 'Back to settings',
      open: 'Open',
      catalogRecordsTitle: '{{catalog}} records',
      catalogRecordsDescription: 'Catalog to manage {{catalog}}.',
      catalogCreateTitle: 'Add {{catalog}}',
      catalogEditTitle: 'Edit {{catalog}}',
      catalogDeleteTitle: 'Delete {{catalog}}',
      catalogCreateSubtitle: 'Capture the main {{catalog}} details.',
      catalogEditSubtitle: 'Update the main {{catalog}} details.',
      catalogDeleteSubtitle: 'This action will delete {{catalog}} {{name}}.',
      catalogDeleteSubtitleFallback: 'This action will delete the selected record.',
      catalogEmptyTitle: 'No records in this catalog',
      catalogEmptyDescription: 'There are no available items for {{catalog}}.',
      catalogNotFoundTitle: 'Catalog not found',
      catalogNotFoundDescription: 'No definition is available for the requested catalog.',
      warehousesTitle: 'Warehouses',
      warehousesDescription: 'Define warehouses and operational inventory control points.',
      addWarehouse: 'Add warehouse',
      editWarehouse: 'Edit warehouse',
      deleteWarehouseTitle: 'Delete warehouse',
      deleteWarehouseSubtitle: 'This action will delete warehouse {{name}}.',
      deleteWarehouseSubtitleFallback: 'This action will delete the selected warehouse.',
      warehouseModalTitle: 'Add warehouse',
      warehouseModalSubtitle: 'Capture the operational warehouse details.',
      warehouseEditSubtitle: 'Update the operational warehouse details.',
      categorySingular: 'category',
      unitSingular: 'unit',
      customerTypeSingular: 'customer type',
      movementTypeSingular: 'movement type',
      packagingTypeSingular: 'packaging type',
      providerSingular: 'supplier',
      clientSingular: 'customer',
      categoriesTitle: 'Categories',
      categoriesDescription: 'Classify products by group or family.',
      unitsTitle: 'Units of measure',
      unitsDescription: 'Define operational units for inventory, supplies, and sales.',
      packagingTypesTitle: 'Packaging types',
      packagingTypesDescription: 'Define commercial packaging types such as boxes and pallets with their direct equivalence in pieces.',
      exchangeRateTitle: 'Exchange rate',
      exchangeRateDescription: 'Manage the operational parity between MXN and USD.',
      exchangeRateListDescription: 'Update the MXN/USD parity used by the system.',
      exchangeRateCardTitle: 'MXN/USD parity',
      exchangeRateCardDescription: 'Configure the current buy and sell exchange rates used for operations and reporting.',
      exchangeRateHistoryTitle: 'Exchange rate history',
      exchangeRateHistoryDescription: 'Review the previously registered MXN/USD rates.',
      exchangeRateRecordedAtLabel: 'Recorded on',
      exchangeRateBuyLabel: 'Buy exchange rate',
      exchangeRateBuyHint: 'Buy value in Mexican pesos for one U.S. dollar.',
      exchangeRateSellLabel: 'Sell exchange rate',
      exchangeRateSellHint: 'Sell value in Mexican pesos for one U.S. dollar.',
      exchangeRateEffectiveDateLabel: 'Effective date',
      exchangeRateEffectiveDateHint: 'Enter the business effective date. It may be current, future, or retroactive.',
      exchangeRateEffectiveDateValidation: 'Enter a valid effective date.',
      exchangeRateValidation: 'Enter exchange rates greater than zero.',
      exchangeRateSellGreaterOrEqualValidation: 'The sell exchange rate must be greater than or equal to the buy exchange rate.',
      exchangeRateSaveHelp: 'Saving registers a new effective rate and preserves the history, including the current record.',
      exchangeRateConfirmTitle: 'Confirm exchange rate',
      exchangeRateConfirmSubtitle: 'Review the values before saving the new effective rate.',
      exchangeRateFinalConfirmTitle: 'Final confirmation',
      exchangeRateFinalConfirmSubtitle: 'This action will register the new effective rate.',
      exchangeRateFinalConfirmQuestion: 'Are you sure?',
      exchangeRateFinalConfirmAction: 'Save',
      saveExchangeRate: 'Save exchange rates',
      baseCurrencyLabel: 'Base currency',
      quoteCurrencyLabel: 'Quote currency',
      lastUpdatedLabel: 'Last updated',
      movementTypesTitle: 'Movement types',
      movementTypesDescription: 'Define inbound and outbound reasons for inventory records.',
      providersTitle: 'Suppliers',
      providersDescription: 'Manage supplier contact and commercial relationship data.',
      clientsTitle: 'Customers',
      clientsDescription: 'Manage recurring customers for orders and follow-up.',
    } as const;
